import { render, staticRenderFns } from "./setting-auto-doc.vue?vue&type=template&id=50d909a0&scoped=true"
import script from "./setting-auto-doc.vue?vue&type=script&lang=js"
export * from "./setting-auto-doc.vue?vue&type=script&lang=js"
import style0 from "./setting-auto-doc.vue?vue&type=style&index=0&id=50d909a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d909a0",
  null
  
)

export default component.exports